import { ROUTES } from '../lib/routes';
import { showToast } from '../components/toast';
import { el } from '../utils/dom';
import { getPortalProfile, putPortalProfile } from '../api/profilePortal';

function textField(label: string, type: string, placeholder: string): HTMLElement {
  const wrap = el('div', { className: 'ev123-field' });
  const input = el('input', { className: 'ev123-input', type, placeholder }) as HTMLInputElement;
  wrap.append(el('label', { className: 'ev123-label', text: label }), input);
  return wrap;
}

export function renderProfilePage(root: HTMLElement): void {
  const wrap = el('div', {});

  wrap.append(
    el('div', { className: 'ev123-page-head' }, [
      el('div', { className: 'ev123-container' }, [
        el('h1', { className: 'ev123-page-head__title', text: '내 프로필' }),
        el('p', {
          className: 'ev123-page-head__lead',
          text: '이름·연락처·단지명 등 기본 정보를 수정할 수 있습니다.',
        }),
      ]),
    ])
  );

  const container = el('div', { className: 'ev123-container' });
  const card = el('div', { className: 'ev123-card' });

  const back = el('a', {
    className: 'ev123-btn ev123-btn--header-subtle ev123-btn--sm',
    href: ROUTES.myApplications,
    'data-nav': '',
    style: 'display:inline-block;margin-bottom:1rem',
  }) as HTMLAnchorElement;
  back.textContent = '← 신청내역';

  const nameF = textField('이름', 'text', '이름');
  const phoneF = textField('연락처', 'tel', '010-0000-0000');
  const emailF = textField('이메일', 'email', 'email@example.com');
  const complexF = textField('단지명', 'text', '단지·아파트명');

  card.append(back, nameF, phoneF, emailF, complexF);

  const save = el('button', {
    type: 'button',
    className: 'ev123-btn ev123-btn--primary ev123-btn--block',
    style: 'margin-top:1rem',
  }) as HTMLButtonElement;
  save.textContent = '저장';

  card.appendChild(save);
  container.appendChild(card);
  wrap.appendChild(container);
  root.appendChild(wrap);

  const q = (field: HTMLElement) => field.querySelector('input') as HTMLInputElement | null;

  getPortalProfile()
    .then((p) => {
      q(nameF)!.value = p.name ?? '';
      q(phoneF)!.value = p.phone ?? '';
      q(emailF)!.value = p.email ?? '';
      q(complexF)!.value = p.complexName ?? '';
    })
    .catch((e) => {
      showToast(e instanceof Error ? e.message : '프로필을 불러오지 못했습니다.');
    });

  save.addEventListener('click', async () => {
    save.disabled = true;
    const prev = save.textContent;
    save.textContent = '저장 중…';
    try {
      await putPortalProfile({
        name: q(nameF)?.value?.trim() || undefined,
        phone: q(phoneF)?.value?.trim() || undefined,
        email: q(emailF)?.value?.trim() || undefined,
        complexName: q(complexF)?.value?.trim() || undefined,
      });
      showToast('저장되었습니다.');
    } catch (e) {
      showToast(e instanceof Error ? e.message : '저장에 실패했습니다.');
    } finally {
      save.disabled = false;
      save.textContent = prev ?? '저장';
    }
  });
}
